import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Hash, Plus, Construction } from "lucide-react";

const CodigosLicores = () => {
  return (
    <div className="space-y-6" data-testid="codigos-licores-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 bg-purple-100 rounded-lg flex items-center justify-center">
            <Hash className="w-6 h-6 text-purple-700" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Códigos de Licores</h1>
            <p className="text-sm text-slate-500">
              Catálogo de códigos de tipos y variedades de licores
            </p>
          </div>
        </div>
        <Button disabled className="bg-purple-600 hover:bg-purple-700 text-white" data-testid="btn-new-codigo-licor">
          <Plus className="w-4 h-4 mr-2" /> Nuevo Código
        </Button>
      </div>

      <Card className="border-dashed border-2 border-slate-300">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-slate-700">
            <Construction className="w-5 h-5 text-purple-600" /> Submódulo en construcción
          </CardTitle>
          <CardDescription>
            Los campos del catálogo serán definidos próximamente. Este submódulo incluirá:
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="text-sm text-slate-600 space-y-2 list-disc ml-5">
            <li>Código único del licor</li>
            <li>Nombre / denominación del tipo de licor</li>
            <li>Descripción detallada</li>
            <li>Categoría (Vino, Cerveza, Ron, Whisky, Aguardiente, etc.)</li>
            <li>Grado alcohólico</li>
            <li>Unidad de medida (ml, L, botella)</li>
            <li>Clasificación fiscal vinculada</li>
            <li>Estatus (Activo / Descatalogado)</li>
          </ul>
          <p className="mt-4 text-xs text-slate-400 italic">
            Comparta los campos específicos con el equipo de desarrollo para habilitar este submódulo.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CodigosLicores;
